export const isTouchDevice = () => {
    // modern way
    const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const canHover = window.matchMedia("(hover: hover)").matches;

    // traditional way as fallback
    const hasTouchEvents = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    return (hasCoarsePointer && !canHover) || hasTouchEvents;
}